// assets/tc-shape-switcher.js
(function () {
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const wrap = $('#tc-map-tool');
  if (!wrap) return;

  // Helper: (re)apply the PNG overlay img based on wrap.dataset + viewport
  function applyOverlayFromDataset() {
    const img = wrap.querySelector('.tc-overlay');
    if (!img) return;

    const mq = window.matchMedia('(max-width: 900px)');
    const mobile = mq.matches;

    const src  = mobile ? wrap.dataset.overlayMobile  : wrap.dataset.overlayDesktop;
    const scl  = parseFloat(mobile ? wrap.dataset.mobileScale  : wrap.dataset.desktopScale)  || 1;
    const offX = parseFloat(mobile ? wrap.dataset.mobileOffsetX: wrap.dataset.desktopOffsetX) || 0;
    const offY = parseFloat(mobile ? wrap.dataset.mobileOffsetY: wrap.dataset.desktopOffsetY) || 0;

    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    img.style.transform =
      `translate(calc(-50% + ${offX}px), calc(-50% + ${offY}px)) scale(${scl})`;
  }

  // Apply current dataset overlay on load + resize
  (function bootstrapOverlaySync(){
    const mq = window.matchMedia('(max-width: 900px)');
    applyOverlayFromDataset();
    (mq.addEventListener ? mq.addEventListener('change', applyOverlayFromDataset) : mq.addListener(applyOverlayFromDataset));
    window.addEventListener('resize', applyOverlayFromDataset);
  })();

  // Pickers: your shape tiles already exist with .tc-tile[data-shape="..."]
  const tiles = $$('.tc-tile[data-shape]');
  if (!tiles.length) return;

  function setTileActive(txt){
    tiles.forEach(b => b.classList.toggle('is-active', b.dataset.shape === txt));
    const picked = $('#tc-jewelry-picked-' + (wrap.dataset.tcId || ''));
    if (picked) picked.textContent = txt;
  }

  // The main updater: take a shape label, read window.TCShapeConfig, push into data-*, notify listeners
  function updateShape(shapeLabel) {
    const cfg = (window.TCShapeConfig || {})[shapeLabel];
    if (!cfg) { console.warn('[TC] No shape config for', shapeLabel); return; }

    // Push config → data-attributes (so existing code paths work)
    wrap.dataset.product         = cfg.product;
    wrap.dataset.overlayDesktop  = cfg.overlayDesktop;
    wrap.dataset.overlayMobile   = cfg.overlayMobile;
    wrap.dataset.desktopScale    = cfg.desktopScale;
    wrap.dataset.desktopOffsetX  = cfg.desktopOffsetX;
    wrap.dataset.desktopOffsetY  = cfg.desktopOffsetY;
    wrap.dataset.mobileScale     = cfg.mobileScale;
    wrap.dataset.mobileOffsetX   = cfg.mobileOffsetX;
    wrap.dataset.mobileOffsetY   = cfg.mobileOffsetY;
    wrap.dataset.accessory       = cfg.accessory;
    wrap.dataset.accessoryOx     = cfg.accessoryOx;
    wrap.dataset.accessoryOy     = cfg.accessoryOy;

    // NEW: Z offset for accessory
    if (cfg.accessoryOz != null) { wrap.dataset.accessoryOz = cfg.accessoryOz; }
    else { delete wrap.dataset.accessoryOz; }

    // === zoom bias: write if provided; otherwise clear so viewer defaults to 1 ===
    if (cfg.zoomBiasDesktop != null) {
      wrap.dataset.zoomBiasDesktop = cfg.zoomBiasDesktop;
    } else {
      delete wrap.dataset.zoomBiasDesktop;
    }
    if (cfg.zoomBiasMobile != null) {
      wrap.dataset.zoomBiasMobile = cfg.zoomBiasMobile;
    } else {
      delete wrap.dataset.zoomBiasMobile;
    }

    // Re-apply overlay immediately (Leaflet keeps running under it)
    applyOverlayFromDataset();

    // Tell viewer + fetcher the shape changed (they’re already listening)
    document.dispatchEvent(new CustomEvent('tc:shape-change', {
      detail: {
        product:       cfg.product,
        accessory:     cfg.accessory,
        accessoryOx:   cfg.accessoryOx,
        accessoryOy:   cfg.accessoryOy,
        accessoryOz:   cfg.accessoryOz,   // NEW in event detail
        // include zoom bias (undefined means "use default 1")
        zoomBiasDesktop: cfg.zoomBiasDesktop,
        zoomBiasMobile:  cfg.zoomBiasMobile
      }
    }));

        // If the 3D overlay is currently open, immediately show the spinner
      // and enqueue a debounced build (the actual network call will be wired in tc-pendant-fetch.js).
      const isOverlayOpen = wrap.classList.contains('overlay-open');
      if (isOverlayOpen) {
        try { document.dispatchEvent(new CustomEvent('tc:pendant-build-start')); } catch(_) {}
        // Queue a build; tc-pendant-fetch.js will debounce & execute after ~300–500ms
        try { document.dispatchEvent(new CustomEvent('tc:queue-build', { detail: { reason: 'shape-change' } })); } catch(_) {}
      }


    setTileActive(shapeLabel);
  }

  // Click wiring
  tiles.forEach(btn => {
    btn.addEventListener('click', () => updateShape(btn.dataset.shape));
  });

  // On load, make sure the currently active tile applies its config once
  const active = tiles.find(b => b.classList.contains('is-active')) || tiles[0];
  if (active) updateShape(active.dataset.shape);
})();
